/** Local dev or the test site — never the live one (testing aids only). */
export const TEST_SITE =
  import.meta.env.DEV ||
  /^(test\.|localhost$|127\.)/.test(window.location.hostname);

/** This browser has signed in as a returning operative through the gate. */
export const KNOWN_KEY = "secret-missions-known";

/**
 * Whether a visitor arrived with nothing that says who they are or who
 * invited them, and so meets the entry gate first: no key (`/code/…` keeps
 * its code), no texted link (its signed `op` on the URL, or one kept from
 * an earlier link), no run on this browser, and not signed in here before.
 *
 * A guide for someone who wandered in, not a lock: it runs in the browser,
 * so anyone set on it gets past (and the server cannot yet tell an unknown
 * key code from an unclaimed one).
 */
export const arrivedWithNothing = () => {
  try {
    const q = new URLSearchParams(window.location.search);
    // every link we text carries op (a bare ?go= or ?m= is not one of ours)
    if (q.has("op")) return false;
    if (localStorage.getItem("secret-missions-ref")) return false;
    if (localStorage.getItem("secret-missions-op")) return false;
    if (localStorage.getItem(KNOWN_KEY)) return false;
    const run = JSON.parse(
      localStorage.getItem("secret-missions-stepper") || "null",
    ) as { state?: { currentStepName?: string } } | null;
    return !run?.state?.currentStepName;
  } catch {
    return false;
  }
};

/** The key code in a scanned link, or null when it is not one of ours. */
export const keyCodeFrom = (data: string): string | null => {
  try {
    const url = new URL(data, window.location.origin);
    const sameSite =
      url.origin === window.location.origin ||
      /(^|\.)secretmissions\.com$/i.test(url.hostname);
    const m = url.pathname.match(/^\/code\/([^/]+)\/?$/);
    return sameSite && m ? decodeURIComponent(m[1]) : null;
  } catch {
    return null;
  }
};
